import cx from "classnames";
import React from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { Timer } from "@gaming/xds-react-js-icons";

import { useStrings } from "../../../localization/localizationHelpers";
import * as styles from "./TimerIcon.module.css";

export type TimerIconProps = Readonly<{
  size?: "S" | "L";
}>;

export const TimerIcon = ({ size }: TimerIconProps) => {
  const [timerIcon] = useStrings("timerIcon");

  return (
    <Icon
      className={cx(styles.timerIcon, size === "S" ? styles.timerIconSmall : styles.timerIconLarge)}
      icon={Timer}
      title={timerIcon}
      iconSize={IconSize.Custom}
    />
  );
};
